import {postJson} from './httpJson'
import {post} from './http'
const baseUrl = '/api/capwhale/enrollevent/mob'

// 活动详情
export const getEventInfo = v => postJson(`${baseUrl}/event/getEventDetail`, v.data, v.success, v.error)
// 票种列表
export const getEventTicketInfo = v => postJson(`${baseUrl}/event/getEventTicketInfo `, v.data, v.success, v.error)
// 活动报名人员列表
export const getEventTicketUser = v => postJson(`${baseUrl}/getEventTicketUser`, v.data, v.success, v.error)
// 海报列表
export const getEventPosterList = v => postJson(`${baseUrl}/getEventPosterList`, v.data, v.success, v.error)
// 获取单个海报
export const getEventSinglePosterInfo = v => postJson(`${baseUrl}/getEventSinglePosterInfo`, v.data, v.success, v.error)

// 订单列表
export const getEventOrderList = v => postJson(`${baseUrl}/getEventOrderList`, v.data, v.success, v.error)
// 我领取的票券列表
export const getEventGettedTickets = v => postJson(`${baseUrl}/getEventGettedTickets`, v.data, v.success, v.error)
// 单个票券详情
export const getEventOrderTicket = v => postJson(`${baseUrl}/getEventOrderTicket`, v.data, v.success, v.error)
// 订单详情
export const getEventOrderDetail = v => postJson(`${baseUrl}/getEventOrderDetail`, v.data, v.success, v.error)
// 取消订单
export const cancelEventOrder = v => postJson(`${baseUrl}/cancelEventOrder`, v.data, v.success, v.error)
// 票券分享
export const saveEventShareTicket = v => postJson(`${baseUrl}/uploadEventShareTicket`, v.data, v.success, v.error)
// 获取分享的票券信息
export const getShareTicketList = v => postJson(`${baseUrl}/getShareTicketList`, v.data, v.success, v.error)
// 获取分享详情
export const getShareDeatil = v => postJson(`${baseUrl}/getShareDeatil`, v.data, v.success, v.error)
// 领取票券
export const saveShareTicketForGet = v => postJson(`${baseUrl}/saveShareTicketForGet`, v.data, v.success, v.error)
// 获取订单详情（确认订单）
export const getConfirmOrderinfo = v => postJson(`${baseUrl}/getConfirmOrderinfo`, v.data, v.success, v.error)
// 获取报名用户信息列表
export const getEnrollEventTicketUser = v => postJson(`${baseUrl}/getEnrollEventTicketUser `, v.data, v.success, v.error)
// 查询新增报名用户配置
export const getEventFormInfo = v => postJson(`${baseUrl}/getEventFormInfo `, v.data, v.success, v.error)
// 查询报名用户信息
export const getEventTicketUserInfo = v => postJson(`${baseUrl}/getEventTicketUserInfo `, v.data, v.success, v.error)
// 新增/修改报名用户信息
export const saveOrUpdateEventTicketUser = v => postJson(`${baseUrl}/saveOrUpdateEventTicketUser`, v.data, v.success, v.error)
// 提交订单(wu)
export const saveEventOrderInfo = v => postJson(`${baseUrl}/uploadEventOrderInfo`, v.data, v.success, v.error)
// 获取支付结果
export const queryOrderPayResult = v => postJson(`${baseUrl}/getOrderPayResult`, v.data, v.success, v.error)
// 获取支付url(订单号)
export const getOrderPayUrl = v => postJson(`${baseUrl}/getOrderPayUrl`, v.data, v.success, v.error)
// 获取代签到列表
export const getEventSignticket = v => postJson(`${baseUrl}/getEventSignticket`, v.data, v.success, v.error)
// 保存签到
export const updateEventSignticket = v => postJson(`${baseUrl}/updateEventSignticket `, v.data, v.success, v.error)

// 新增
// 搜索列表
export const getSearchList = v => postJson(`${baseUrl}/search/getSearchList`, v.data, v.success, v.error)
//
export const getGuessLikeList = v => postJson(`${baseUrl}/index/getGuessLikeList `, v.data, v.success, v.error)
// 主页
export const getIndexInfo = v => postJson(`${baseUrl}/index/getIndexInfo`, v.data, v.success, v.error)
// 关注
export const operateHostFollowInfo = v => postJson(`${baseUrl}/event/operateHostFollowInfo `, v.data, v.success, v.error)
// 主办方详情
export const getHostDetail = v => postJson(`${baseUrl}/event/getHostDetail`, v.data, v.success, v.error)
// 主办方活动列表
export const getEventByHost = v => postJson(`${baseUrl}/event/getEventByHost`, v.data, v.success, v.error)
// 活动订单详情
export const getOrderDetailByEnroll = v => post(`/api/capwhale/center/getOrderDetailByEnroll`, v.data, v.success, v.error)
// 取消订单
export const cancelEventOrderByEnroll = v => post(`/api/capwhale/center/cancelEventOrderByEnroll`, v.data, v.success, v.error)
// 支付订单
export const getAaOrderPayUrl = v => post(`/api/capwhale/pay/getOrderPayUrl`, v.data, v.success, v.error)
// 支付订单
export const getAaOrderPayResult = v => postJson(`/api/capwhale/enrollevent/mob/getOrderPayResult`, v.data, v.success, v.error)

//签到董秘
export const signTicketByAdminHost = v => postJson(`/api/capwhale/enrollevent/mob/signTicketByAdminHost`, v.data, v.success, v.error)